import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";

import GmapMultiple from "./GmapMultiple";

const FarmerOneMapForm = (props) => {
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [farmerId, setfarmerId] = useState();
  const [farmerListData, setFarmerListData] = useState([]);
  const [farmerinformationData, setfarmerinformationData] = useState([]);
  const [plotDataList, setplotDataList] = useState([]);

  const [cropDataList, setcropDataList] = useState([]);
  const [cropList, setcropList] = useState([]);
  const [farmDetails, setfarmDetails] = useState([]);
  const [farmer, setfarmer] = useState([]);
  const [ngoDetails, setngoDetails] = useState([]);
  const [livestock, setlivestock] = useState([]);
  const [familydDetail, setfamilyDetail] = useState([]);
  const [machineryDetails, setmachineryDetails] = useState([]);

  const [regionId, setRegionId] = useState(0);
  const [regionData, setRegionData] = useState([]);

  const [totalLand, settotalLand] = useState(0);
  const [cropsCount, setcropsCount] = useState(0);

  const [coordinate, setcoordinate] = useState([]);
  const [marketCoordinate, setMarketCoordinate] = useState([]);
  const [plotCoordinateList, setPlotCoordinateList] = useState([]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRegionData(data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerDashBoardView } = useHttp();

  const FarmerDashBoardView = (farmerId) => {
    getFarmerDashBoardView(
      {
        url: `/api/getFarmerDashBoardView/?farmerId=${farmerId}`,
      },
      (data) => {
        if (data) {
          // //console.log("farmerData", data.output);
          settotalLand(data.output.totalLand);
          setcropsCount(data.output.cropsCount);
        }
      }
    );
  };

  const { sendRequest: getEmp } = useHttp();
  const getEmployeeData = (id) => {
    setFarmerListData([]);
    setfarmerinformationData([]);

    if(id==0)
    {
      id=1;
    }
    var url = `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
      "empId"
    )}&orgId=${localStorage.getItem("orgId")}`;

    if (id > 0) {
      var url = `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
        "empId"
      )}&orgId=${localStorage.getItem("orgId")}&regionId=${id}`;
    }
    else
    {
      var url = `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
        "empId"
      )}&orgId=${localStorage.getItem("orgId")}&regionId=1`;
    }
    

    getEmp(
      {
        url: url,
      },
      (data) => {
        setEmployeeData(data);
        getFarmersData(0);
      }
    );
  };

  const { sendRequest: getFarmers } = useHttp();

  const getFarmersData = (empId) => {
    // farmerSelectListData=[];
    setFarmerListData([]);
    setfarmerinformationData([]);
    // //console.log("empId", empId);
    getFarmers(
      {
        url: `/api/getfarmerDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&fieldExecutiveId=${empId}`,
      },
      (data) => {
        // //console.log("data.farmerDetails", data);

        data = data.output.sort((a, b) =>
          a.farmerName > b.farmerName ? 1 : -1
        );

        setFarmerListData(data);
      }
    );
  };

  const { sendRequest: getPlot } = useHttp();

  const getPlotData = (region_Id, employee_Id, farmer_Id) => {
    // const pdata = { createdBy: 5 };
    // farmerSelectListData=[];

    var markerList = [];
    var PlotCoordinatetempList = [];

    setMarketCoordinate(markerList);
    setPlotCoordinateList(PlotCoordinatetempList);

    var urlfilter = "";

    if (region_Id > 0) {
      urlfilter = urlfilter + `&regionId=${region_Id}`;
    }

    if (employee_Id > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employee_Id}`;
    }

    if (farmer_Id > 0) {
      urlfilter = urlfilter + `&farmerId=${farmer_Id}`;
    }

    getPlot(
      {
        url: `/api/getfarmerPlotDetailForMap/?orgId=${localStorage.getItem(
          "orgId"
        )}${urlfilter} `,
      },
      (data) => {
        var filterplot = data.plot;
        var filterCrop = data.crop;

        setplotDataList(filterplot);
        setcropDataList(filterCrop);

        var polId = 1;

        try {
          
          

        filterplot.forEach((item) => {
          var coordinates = {};
          
          // console.log("farmerName",item && item.farmerName)
          console.log("length",item && item.plotCoordinates)

          if (item.plotCoordinates &&  item.plotCoordinates.length>0) {
            var plotCorodinate = [];

            if (item.plotCoordinates.includes('"')) {
              plotCorodinate = JSON.parse(item.plotCoordinates);
            } else {
              plotCorodinate = item.plotCoordinates;
            }

            coordinates = {
              lat: plotCorodinate[0].latitude,
              lng: plotCorodinate[0].longitude,
            };
            // console.log("item plotId", item.plotId);
            var cropselectItem = filterCrop.filter(
              (eitem) => eitem.plotId == item.plotId
            );

            var colorcode = "Red";
            var croplist = "";

            // console.log("cropselectItem", cropselectItem);
            if (cropselectItem && cropselectItem.length > 0) {
              var cropItem = cropselectItem[0];

              // console.log("map color", cropItem.mapColor);
              colorcode = cropItem.mapColor;
              // if ((cropItem.procurement || "") != "") {
              //   colorcode = "Green";
              // } else if ((cropItem.fieldQc || "") != "") {
              //   colorcode = "#ffbf00";
              // } else if (
              //   (cropItem.pruningDate || "") != "" ||
              //   (cropItem.sowingDate || "") != ""
              // ) {
              //   colorcode = "Cyan";
              // } else {
              //   colorcode = "Red";
              // }

              croplist = cropItem.farmerName + " (" + cropItem.cropName + ")";
            }

            markerList = markerList.concat({
              lat: plotCorodinate[0].latitude,
              lng: plotCorodinate[0].longitude,
              tittleName: item.farmerName ,
              markeyType: colorcode,
            });

            var plotNewCoordinates = [];

            plotCorodinate.map((item) => {
              plotNewCoordinates = plotNewCoordinates.concat({
                lat: item.latitude,
                lng: item.longitude,
              });
            });

            // console.log("set color", colorcode);

            PlotCoordinatetempList = PlotCoordinatetempList.concat({
              plotCorodinate: plotNewCoordinates,
              colorCode: colorcode,
              id: "ply" + polId,
            });
          }

          polId = polId + 1;
        });
      } catch (e) {
        console.log('Error',e)
        }
        // console.log("markerList",markerList)
        setMarketCoordinate([...markerList]);
        setPlotCoordinateList([...PlotCoordinatetempList]);

        if (PlotCoordinatetempList.length > 0) {
          setcoordinate([...PlotCoordinatetempList[0].plotCorodinate]);
        }
        // console.log("markerList",markerList,"PlotCoordinatetempList",PlotCoordinatetempList,marketCoordinate,coordinate);
      }
    );
  };

  useEffect(() => {
    getPlotData();
  }, []);

  return (
    <>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-6">
            <label className="card-title">
              {" "}
              &nbsp; &nbsp;Farmer One Detail{" "}
            </label>{" "}
          </div>

          <div className="col-3"> </div>
          <div className="col-3 text-right"></div>
        </div>
        <br />

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4"> </div>
                    </div>

                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Region</label>
                          <select
                            id="regionId"
                            className="form-control"
                            ref={(el) => (frmRef.current["regionId"] = el)}
                            value={regionId}
                            onChange={(e) => {
                              var id = 0;
                              if (e.target.value != "") id = e.target.value;

                              setRegionId(id);
                              getEmployeeData(id);
                              getPlotData(id, 0, 0);
                            }}
                          >
                            <option value="">--All Region--</option>
                            {regionData &&
                              regionData.map((x) => (
                                <option
                                  key={x.regionId}
                                  user-id={x.regionId}
                                  value={x.regionId}
                                >
                                  {x.regionName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor={"executive_officer"}>
                            {"Procurement Officer"}
                          </label>
                          <select
                            id="emp_id"
                            className="form-control"
                            ref={(el) => (frmRef.current["emp_id"] = el)}
                            value={employeeId}
                            onChange={(e) => {
                              var empid = 0;
                              if (e.target.value != "") empid = e.target.value;
                              setEmployeeId(empid);

                              getFarmersData(empid);
                              getPlotData(regionId, empid, 0);
                            }}
                          >
                            <option>--Select Employee--</option>
                            {employeeData &&
                              employeeData.map((x) => (
                                <option
                                  key={x.user}
                                  user-id={x.userId}
                                  value={x.userId}
                                >
                                  {x.employeeName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label>{"Farmer Name"}</label>
                          <select
                            id="farmerId"
                            className="form-control"
                            ref={(el) => (frmRef.current["farmerId"] = el)}
                            value={farmerId}
                            onChange={(e) => {
                              setfarmerId(e.target.value);
                              getPlotData(regionId, employeeId, e.target.value);
                            }}
                          >
                            <option value="">--Select Farmer--</option>
                            {farmerListData &&
                              farmerListData.map((x) => (
                                <option
                                  key={x.farmerId}
                                  farmer-id={x.farmerId}
                                  value={x.farmerId}
                                >
                                  {x.farmerName + "(" + x.farmerNo + ")"}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="form-group">
                          <label>&nbsp;</label>
                          <button
                            className="form-control btn btn-sm btn-primary"
                            onClick={() => {
                              getPlotData(regionId, employeeId, farmerId);
                            }}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4"> </div>
                    </div>

                    <div className="row">
                      <div className="col-3">
                        <div className="info-box">
                          <span
                            className="info-box-icon"
                            style={{ "background-color": "red" }}
                          >
                            {" "}
                            &nbsp;
                          </span>
                          <div className="info-box-content">
                            <span className="info-box-text"> Contract </span>
                            <span className="info-box-text"> Pending</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="info-box">
                          <span
                            className="info-box-icon"
                            style={{ "background-color": "Cyan" }}
                          >
                            {" "}
                          </span>

                          <div className="info-box-content">
                            <span className="info-box-text">Contract </span>
                            <span className="info-box-text"> Completed</span>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div className="info-box">
                          <span
                            className="info-box-icon"
                            style={{ "background-color": "#ffbf00" }}
                          >
                            {" "}
                          </span>
                          <div className="info-box-content">
                            <span className="info-box-text"> Procurement </span>
                            <span className="info-box-text"> Pending</span>
                          </div>
                        </div>{" "}
                      </div>

                      <div className="col-3">
                        <div className="info-box">
                          <span
                            className="info-box-icon"
                            style={{ "background-color": "Green" }}
                          >
                            {" "}
                          </span>
                          <div className="info-box-content">
                            <span className="info-box-text">Procurement </span>
                            <span className="info-box-text"> Completed</span>
                          </div>
                        </div>{" "}
                      </div>
                    </div>

                    <div className="row">
                      <div style={{ width: "500px", height: "400px" }}>
                        <GmapMultiple
                          coordinate={coordinate}
                          marketCoordinate={marketCoordinate}
                          plotCoordinateList={plotCoordinateList}
                          mapzoom={17}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerOneMapForm;
